import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { QRCodeSVG } from 'qrcode.react';
import { getSliceContent } from '../selectors';
import get from '../helpers/get';
import theme from '../styles/theme';

const DailyFeedPreview = ({ classes, deepLinkBaseUrl }) => {
  const [deepLink, setDeepLink] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token'); // eslint-disable-line no-undef
    if (deepLinkBaseUrl && token) {
      setDeepLink(`${deepLinkBaseUrl}?token=${encodeURIComponent(token)}#feed`);
    } else if (deepLinkBaseUrl) {
      setError('No preview token found. Please open this page by clicking the Preview button and selecting "Daily Feed Preview".');
    }
  }, [deepLinkBaseUrl]);

  return (
    <div className={classes.container}>
      {error && (
        <p className={classes.error}>{error}</p>
      )}
      {deepLink && (
        <>
          <div className={classes.qrWrapper}>
            <QRCodeSVG value={deepLink} size={200} />
          </div>
          <div className={classes.linkWrapper}>
            <a className={classes.link} href={deepLink}>
              {deepLink}
            </a>
          </div>
        </>
      )}
    </div>
  );
};

DailyFeedPreview.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  deepLinkBaseUrl: PropTypes.string,
};

DailyFeedPreview.defaultProps = {
  deepLinkBaseUrl: undefined,
};

const mapStateToProps = (state, { sliceId }) => {
  const content = getSliceContent(state, sliceId);
  return {
    deepLinkBaseUrl: get(content, ['deep_link_base_url']),
  };
};

export default compose(
  connect(mapStateToProps),
  injectSheet({
    container: {
      padding: '40px 0',
      maxWidth: '600px',
      margin: '0 auto',
    },
    qrWrapper: {
      marginBottom: '24px',
      display: 'flex',
      justifyContent: 'center',
    },
    linkWrapper: {
      wordBreak: 'break-all',
      padding: '16px',
      background: theme.colors.contrastBg,
    },
    link: {
      color: theme.colors.secondary,
      fontSize: '14px',
      fontFamily: theme.fonts.body,
    },
    error: {
      color: theme.colors.urgency,
      fontSize: '14px',
      fontFamily: theme.fonts.body,
    },
  }),
)(DailyFeedPreview);
